export const faqData = [
  // {
  //   question: "What is it?",
  //   answer: `It is a digital journal built for more meaningful years, more focused weeks and happier, healthier days. To achieve this it marries 3 previously independent and useful things; a mindfulness journal, a year planner and a live dashboard.`,
  // },
  // {
  //   question: "How much does it cost?",
  //   answer:
  //     "It is free for as many people as we can host on the site within our current budget. You can donate to support the maintenance and growth of the platform by visiting our 'Donate' page.",
  // },
  // {
  //   question: "What's the catch? How come it is free?",
  //   answer:
  //     "There is no catch, simply a different way of thinking. Don't see this as an app, or a website, see it as a 'commons' i.e. a resource you are using and sharing with other people that is, in turn, being responsibly managed by a steward that has your interests and wellbeing in mind.",
  // },
  {
    question: "Can anyone else see my data?",
    answer:
      "No, only you. All text fields in the journal are encrypted using cryptographic algorithms meaning they are extremely safe and impossible to read. Your data is here to serve one person and one person only: you.",
  },
  {
    question: "What control do I have over my data?",
    answer:
      "Complete control. You can add, view, export, delete or request the complete removal of your data & account at any time. We actively encourage people to do this as it helps us manage our server costs, and doesn't at all stop you from having a positive experience if you wanted to start using the app again.",
  },
  {
    question: "Will anything ever happen to or be done with my data?",
    answer:
      "No, never. Your data is here to serve one person and one person only: you. It will never be sold or leveraged in any other way than to help you learn more about yourself.",
  },
  {
    question: "Is No Wasted Days only this platform?",
    answer:
      "I have a podcast (The NoWastedDays Podcast) and a YouTube Channel.",
  },
  // {
  //   question: "How long does it take to sign up?",
  //   answer:
  //     "If you watch the tutorial, about 2-3 minutes. If you don't, about 10 seconds.",
  // },
  {
    question: "What's the story behind No Wasted Days?",
    answer:
      "It was created 7 years ago at a dark time in my life. I had become hugely stressed and really isolated and, in the depths of that difficult moment, I create a little journalling format in an excel sheet to help give everyday more structure and purpose. Over time, it evolved - with more data, more mindful elements, more insights - to be this huge organising force in my life. People kept asking me about this spreadsheet that I was using and I thought, 'This really should be an app that anyone could use!'. Lots of software development learning later, here we are: a living, breathing platform that anyone can use for free.",
  },
];
